import i18n from 'i18n/config';
import { BoardInstructionTypes } from 'types/Board';

export default {
  [BoardInstructionTypes.ALL_YES]: {
    value: 'ALL_YES',
    text: i18n.t('AllYes'),
  },
  [BoardInstructionTypes.ALL_NO]: {
    value: 'ALL_NO',
    text: i18n.t('AllNo'),
  },
  [BoardInstructionTypes.ALL_ABS]: {
    value: 'ALL_ABS',
    text: i18n.t('AllAbs'),
  },
  [BoardInstructionTypes.POINT_BY_POINT]: {
    value: 'POINT_BY_POINT',
    text: i18n.t('PointByPoint'),
  },
};
